<template>
  <div
    class="puller"
    ref="puller"
  />
</template>

<script>
import { defineComponent, ref } from 'vue';
import usePullDown from '@/composables/usePullDown';

export default defineComponent({
  name: 'PullDownComponent',

  setup() {
    const puller = ref(null);
    usePullDown(puller);

    return {
      puller,
    };
  },
});
</script>

<style lang="scss" scoped>
.puller {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: calc(100% - 250px);
  height: 80px;
  z-index: 1000;

  @media screen and (min-width: $desktop_s_breakpoint) and (orientation: landscape) {
    display: none;
  }
}
</style>
